import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { sensitiveDataReducer } from '@shared/api/reduxToolkit';
import { SENSITIVE_DATA_KEY } from '@shared/constants';

const sensitiveDataPersistConfig = {
	key: SENSITIVE_DATA_KEY,
	version: 1,
	storage,
	whitelist: ['isSensitiveDataVisible'],
};

export const persistedSensitiveDataReducer = persistReducer(sensitiveDataPersistConfig, sensitiveDataReducer);
